import CryptoJS from "crypto-js";
import iconv from "iconv-lite";
import { store } from "redux/store";

function hex2a(hex: string) {
  var str = "";
  for (var i = 0; i < hex.length; i += 2) {
    var v = parseInt(hex.substr(i, 2), 16);
    if (v) str += String.fromCharCode(v);
  }
  return str;
}

function addZero(byteArray: number[]): number[] {
  const isDiff = 8 - byteArray.length;
  let index = 0;
  while (index < isDiff) {
    const zero: number = byteArray[byteArray.length - 1] >>> 8;
    byteArray.push(zero);
    index++;
  }
  return byteArray;
}

function byteArrayToWordArray(ba: number[]) {
  let words: any = [];
  for (let j = 0; j < ba.length; j++) {
    words[j >>> 2] |= ba[j] << (24 - 8 * (j % 4));
  }
  return CryptoJS.lib.WordArray.create(words, ba.length);
}

export const IgsEnc = (input: string): string => {
  const reduxStore = store.getState();
  const key = "B8C0F36CDCD2CD2E5A12E5A198CD2E5A198CD2CD2E5A1CD2";
  const ciphertext =
    "CF80650F524D1ECB0CD453BA892406B482313797289255A909154B674CCA9756878FBF590523BCF8CD69162E7FE7306D";
  const iv = CryptoJS.enc.Hex.parse("0000000000000000");

  const keyHex = CryptoJS.enc.Hex.parse(key);
  const ciphertextHex = CryptoJS.format.Hex.parse(ciphertext);
  let result1 = CryptoJS.TripleDES.decrypt(ciphertextHex, keyHex, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.NoPadding,
  });
  const decResult = result1.toString(CryptoJS.enc.Hex);
  const result_3DES_DEC = hex2a(decResult);

  const clientid = reduxStore.login.clientUID;
  const result_SHA256 = CryptoJS.SHA256(result_3DES_DEC + clientid)
    .toString()
    .substring(0, 48);

  const result_SHA256HEX = CryptoJS.enc.Hex.parse(result_SHA256);

  let bytes2 = iconv.encode(input, "utf-8");
  const arr = Array.from(bytes2);
  const byteArrayAddZero = addZero(arr);
  const wa_input = byteArrayToWordArray(byteArrayAddZero);

  const result_3DES_ENC = CryptoJS.TripleDES.encrypt(
    wa_input,
    result_SHA256HEX,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.NoPadding,
    }
  );

  const result = result_3DES_ENC.toString(CryptoJS.format.Hex).toUpperCase();
  return result;
};
